import { render, staticRenderFns } from "./OnlineStatisicsDetail.vue?vue&type=template&id=6a39f985&scoped=true"
import script from "./OnlineStatisicsDetail.vue?vue&type=script&lang=js"
export * from "./OnlineStatisicsDetail.vue?vue&type=script&lang=js"
import style0 from "./OnlineStatisicsDetail.vue?vue&type=style&index=0&id=6a39f985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39f985",
  null
  
)

export default component.exports